module.exports = __webpack_public_path__ + "img/arrow.4b227508.svg";